<script>
import en from '@/includes/wordpress/header-footer.com.json';
import da from '@/includes/wordpress/header-footer.dk.json';
import de from '@/includes/wordpress/header-footer.de.json';
import es from '@/includes/wordpress/header-footer.es.json';
import fi from '@/includes/wordpress/header-footer.fi.json';
import fr from '@/includes/wordpress/header-footer.fr.json';
import it from '@/includes/wordpress/header-footer.it.json';
import nl from '@/includes/wordpress/header-footer.nl.json';
import no from '@/includes/wordpress/header-footer.no.json';
import sv from '@/includes/wordpress/header-footer.se.json';
// eslint-disable-next-line camelcase
import en_GB from '@/includes/wordpress/header-footer.co.uk.json';
// eslint-disable-next-line camelcase
import de_AT from '@/includes/wordpress/header-footer.at.json';
// eslint-disable-next-line camelcase
import de_CH from '@/includes/wordpress/header-footer.ch.json';
import TheTopMenu from 'frontend-resources/components/Header/TheTopMenu';
import TheHeader from 'frontend-resources/components/Header/TheHeader';
import Footer from 'frontend-resources/components/Footer/Footer';
import HappinessGuarantee from '@/components/HappinessGuarantee';
import VerifyEmailBanner from '@/components/VerifyEmailBanner';
import {
    faChevronDown,
    faUserSecret,
    faSignOutAlt,
    faThLarge,
    faReceipt,
    faTag,
    faCog,
    faUserCircle,
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import Route from '~/extensions/Route/Route';

library.add(faChevronDown, faUserSecret, faSignOutAlt, faUserCircle);

export default {
    components: { VerifyEmailBanner, TheTopMenu, TheHeader, Footer, HappinessGuarantee },
    head() {
        return {
            title: this.$i18n.t(`routes.${this.$route.name}.title`) !== `routes.${this.$route.name}.title`
                ? this.$i18n.t(`routes.${this.$route.name}.title`)
                : this.$i18n.t('global.title'),
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: this.$i18n.t('global.description'),
                },
            ],
        };
    },
    data({ $route }) {
        return {
            showHappinessGuarantee: String($route.name).indexOf('proofreading-orders-id') === 0 || String($route.name) === 'plagiarism-orders-id-overview',
            locales: {
                en,
                en_GB,
                da,
                de,
                de_AT,
                de_CH,
                es,
                fi,
                fr,
                it,
                nl,
                no,
                sv,
            },
            user: this.$store.user,
        };
    },
    computed: {
        menuData: function () {
            return this.locales[this.$i18n.locale];
        },
        accountMenu: function () {
            let accountMenu = [
                {
                    name: this.$i18n.t(`top_menu.dashboard.name`),
                    link: '/student/',
                    icon: faThLarge,
                },
                {
                    name: this.$i18n.t(`top_menu.invoices.name`),
                    link: '/student/invoices/',
                    icon: faReceipt,
                },
            ];

            if (this.$i18n.te(`partners.discount-content`) && this.$i18n.t(`partners.discount-content`).length > 0) {
                accountMenu.push({
                    name: this.$i18n.t(`top_menu.partners.name`),
                    link: '/student/partners/',
                    icon: faTag,
                });
            }

            accountMenu.push(...[
                {
                    name: this.$i18n.t(`top_menu.settings.name`),
                    link: '/student/profile/edit-profile/',
                    icon: faCog,
                },
                {
                    name: this.$i18n.t(`top_menu.logout.name`),
                    link: Route('logout'),
                    icon: faSignOutAlt,
                },
            ]);

            return accountMenu;
        },
        footerLinks: function () {
            const links = {
                'logo_link': [
                    {
                        'link': this.$i18n.t('links.wp.home'),
                        'name': this.$i18n.t('footer.links.home'),
                    },
                ],
                'other_links': [
                    {
                        'link': this.$i18n.t('links.wp.terms_of_use'),
                        'name': this.$i18n.t('footer.links.terms_of_use'),
                    },
                    {
                        'link': this.$i18n.t('links.wp.privacy_policy'),
                        'name': this.$i18n.t('footer.links.privacy_policy'),
                    },
                    {
                        'link': this.$i18n.t('links.wp.contact'),
                        'name': this.$i18n.t('footer.links.contact'),
                    },
                ],
            };

            if (String(this.$route.name) !== 'plagiarism-orders-freemium-id') {
                links.other_links.unshift({
                    'link': this.$i18n.t('links.wp.happiness_guarantee'),
                    'name': this.$i18n.t('footer.links.happiness_guarantee'),
                });
            }

            return links;
        },
    },
};
</script>
